<template>
  <!--意见反馈页面-->
  <div class="comments">
    <van-row>
      <van-col span="22" offset="1" class="my_report_cont_type">

        <van-col span="24" class="my_feedback_cont_type_text">
          <van-field
            v-model="content"
            rows="5"
            autosize
            type="textarea"
            maxlength="200"
            :placeholder="$t('placeholder.feedback_textarea')"
            show-word-limit
          />
          <!-- 请填写您的意见或建议,我们共同改进~ -->
        </van-col>
        <van-col span="24" class="my_report_cont_img_name my_feedback_bor">{{ $t('column.feedback_img') }}</van-col>
        <van-col span="24">
          <van-col span="8" v-for="(t, index) in user_img" :key="t.img" class="my_information_photo">
            <van-image height="6em" :src="t.img" />
            <div class="my_information_photo_del"><van-icon name="cross" @click="photo_del(index)"/></div>
          </van-col>
          <!-- 照片墙按钮 -->
          <van-col span="8" class="my_information_photo" v-if="user_img.length < 4">
            <img src="../assets/img/upd.png"  class="my_information_photo_img" @click="img_upload('img')">
          </van-col>
        </van-col>
        <van-col span="24"><van-field v-model="tel" type="tel" style="border-bottom: 1px solid #F2F2F2;" :placeholder="$t('column.feedback_tel')"/></van-col>
        <van-col span="24" style='color: #C1C0C9;margin-left: -2.5em;margin-top: 7px;' >{{ $t('placeholder.feedback_tel') }}</van-col>
        <van-col span="18" offset="3" @click="report_btn" class="my_report_cont_btn">{{ $t('btn.submit') }}</van-col>
      </van-col>
    </van-row>
  </div>
</template>
<script>
  import { judgeIosAndroid } from '@/assets/js/models.js'
  import { Toast } from 'vant'
  import axios from 'axios'
  export default {
    data() {
      return {
        user_img: [],
        content: '',
        tel: '',
      }
    },
    created: function() {
      document.title = this.$t('title.feedback')
    },
    mounted() {
      // 将要给原生调用的方法挂载到 window 上面
      window.getValueFromApp = this.getValueFromApp
    },
    methods: {
      img_upload (name) {
        // 上传头像
        this.mobile_intercept(name)
      },
      mobile_intercept(name) {
        //  拦截
        const isIos = judgeIosAndroid();
        if (isIos == true) {
          // ios传值方法postMessage（val）传值方式
          window.webkit.messageHandlers.upload_avatar.postMessage(name)
        } else {
          // ios传值方法goSubmitted（val）传值方式
          window.AndroidJs.upload_avatar(name)
        }
      },
      getValueFromApp(name,url) {
        // 上传回调
        // 下载完成回调(ios和android调用接口)
        if (name === 'img') {
          const imgs = {'img': url}
          this.user_img.push(imgs)
        }
      },
      photo_del (index) {
        // 删除图片
        console.log(index)
        this.user_img.splice(index, 1);
      },
      convert() {
        this.user_img = []
        this.tel = ''
        this.content = ''
      },
      report_btn() {
        const uid = this.$route.query.uid
        const token = this.$route.query.token
        let imgs = ''
        for ( let i=0; i < this.user_img.length; i++) {
          imgs += i === 0 ? this.user_img[i].img : ',' + this.user_img[i].img
        }
        if(!this.content){
          Toast(this.$t('Tips.feedback_center'))
          return false
        }
        if(this.tel.length != 11 && this.tel.length != 10 ){
          Toast(this.$t('Tips.feedback_tel'))
          return false
        }
        axios.get(this.baseUrlApi + "mapi/public/index.php/api/feedback_api/add_buy_vue", {
          params: {
            uid: uid,
            token: token,
            content:this.content,
            img: imgs,
            tel: this.tel
          }
        }).then(res => {
          console.log(res);
          Toast(res.data.msg)
          if(res.data.code == 1) {
            this.convert()
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/feedback.vue